(() => {
  // 找到商品頁主要的 add-to-cart form（Woodstock 一般是這個）
  function getMainProductForm(btn) {
    const form = btn.closest('form[action^="/cart/add"]');
    if (form) return form;
    return document.querySelector('form[action^="/cart/add"]');
  }

  function goCart() {
    window.location.href = "/cart";
  }

  function getVariantIdFromForm(form) {
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? Number(idInput.value) : null;
  }

  function getSelectedVariantFromDOM(form) {
    // 優先找 form 旁邊/上層的 data-selected-variant script
    const script =
      form.closest(".product__sale-box, .product, .product__info, main, body")
        ?.querySelector('script[type="application/json"][data-selected-variant]') ||
      document.querySelector('script[type="application/json"][data-selected-variant]');

    if (!script || !script.textContent) return null;
    try {
      const obj = JSON.parse(script.textContent);
      return obj && typeof obj === "object" ? obj : null;
    } catch (_) {
      return null;
    }
  }

  function isFormButtonDisabled(form) {
    // 主題通常會把加入購物車按鈕 disable 掉
    const submitBtn =
      form.querySelector('button[name="add"]') ||
      form.querySelector(".product-form__submit") ||
      form.querySelector('button[type="submit"]');

    if (!submitBtn) return false;

    const ariaDisabled = submitBtn.getAttribute("aria-disabled");
    return (
      submitBtn.disabled === true ||
      ariaDisabled === "true" ||
      submitBtn.classList.contains("disabled") ||
      submitBtn.classList.contains("is-disabled")
    );
  }

  async function isPurchasable(form) {
    // 1) 先信任主題的 disabled 狀態（最快）
    if (isFormButtonDisabled(form)) return false;

    // 2) 再看頁面上的 selected variant JSON
    const v = getSelectedVariantFromDOM(form);
    if (v && typeof v.available === "boolean") return v.available;

    // 3) 最後保險：查 Shopify variants endpoint
    const variantId = getVariantIdFromForm(form);
    if (!variantId) return false;

    try {
      const res = await fetch(`/variants/${variantId}.js`, {
        method: "GET",
        credentials: "same-origin",
        headers: { Accept: "application/json" },
      });
      if (!res.ok) return false;
      const data = await res.json();
      if (typeof data.available === "boolean") return data.available;
    } catch (_) {}

    // 若任何原因無法判定，保守起見：不要硬加
    return false;
  }

  async function addToCartViaForm(form) {
    const fd = new FormData(form);

    const res = await fetch("/cart/add.js", {
      method: "POST",
      body: fd,
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });

    if (!res.ok) throw new Error("add to cart failed");
    return res.json();
  }

  function hijackBuyNow() {
    const wrappers = document.querySelectorAll(".shopify-payment-button");

    wrappers.forEach((wrap) => {
      const btn =
        wrap.querySelector('button[type="submit"]') ||
        wrap.querySelector("button") ||
        wrap.querySelector('input[type="submit"]');

      if (!btn) return;
      if (btn.dataset.ljHijacked === "1") return;
      btn.dataset.ljHijacked = "1";

      btn.addEventListener(
        "click",
        async (e) => {
          e.preventDefault();
          e.stopPropagation();

          const form = getMainProductForm(btn);
          if (!form) return goCart();

          // ✅ 缺貨/不可購買：直接阻擋，不要硬塞進購物車
          const ok = await isPurchasable(form);
          if (!ok) {
            // 你若想要提示可打開這行（或改成主題的 toast）
            // alert("此商品目前缺貨，無法購買。");
            return;
          }

          try {
            await addToCartViaForm(form);
            // 讓主題/其他腳本有時間更新（150ms 通常夠）
            setTimeout(goCart, 150);
          } catch (err) {
            // console.warn("[BuyNow->Cart] failed:", err);
          }
        },
        true
      );
    });
  }

  document.addEventListener("DOMContentLoaded", hijackBuyNow);

  const mo = new MutationObserver(() => hijackBuyNow());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
